// CustomProgressBar.tsx
import React from 'react';
import {Progressbar} from 'src/ui-components/ProgressBar/progressbar';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
    TooltipArrow,
} from 'src/ui-components/Tooltip/tooltip';
import {twMerge} from 'tailwind-merge';

interface ProgressBarProps {
    value: number;
    variant: 'secondary' | 'primary' | 'warning' | 'overflow' | null | undefined;
    indicator?: 'primary' | 'warning' | 'overflow';
    label: string;
    className?: string;
}

const CustomProgressBar: React.FC<ProgressBarProps> = ({value, variant, indicator, label, className}) => {
    indicator = indicator ?? undefined;
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger>
                    <Progressbar
                        value={value}
                        variant={variant}
                        indicator={indicator}
                        className={twMerge('h-[8px] w-[142px]', className)}
                    />
                </TooltipTrigger>
                <TooltipContent>
                    <p>{label}</p>
                    <TooltipArrow />
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default CustomProgressBar;
